import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper, Typography, Button, IconButton, Tooltip } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useDropzone } from 'react-dropzone';
import TareasTerminadas from '../../../general/TareasTerminadas';
import TituloAccion from '../../../general/TituloAccion';
import emma_w from '../../../../global/imagenes/emma_w.png';
import emma_s1 from '../../../../global/imagenes/emma_s1.png';
import icono_xlsx from '../../../../global/imagenes/extensiones/xlsx.png';
import { consulta, obtenerValores } from '../../../../global/js/funciones';
import { PAISES } from '../helper';
import { COLUMNAS, leerArchivo, validarFilas, FORMATO_FECHA } from './excelConvenios';
import { generarPlantilla } from './plantillaConvenios';

const plural = (n, singular, pluralf) => `${n} ${n === 1 ? singular : pluralf}`;

const ROJO = '#900807';
const ROJO_CLARO = '#B70E0C';
const VERDE = '#078030';

// react-dropzone directo: CustomDropzone pinta una lista y aqui va un solo archivo.
function ZonaArchivo({ onArchivo }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: '.xlsx,.xls',
    multiple: false,
    onDrop: (archivos) => { if (archivos && archivos.length > 0) onArchivo(archivos[0]); },
  });
  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #e0e0e0', background: isDragActive ? '#fff1f0' : '#fafafa',
        borderColor: isDragActive ? ROJO_CLARO : '#e0e0e0',
        padding: '36px 24px', display: 'flex', flexDirection: 'column',
        alignItems: 'center', gap: '12px', cursor: 'pointer', textAlign: 'center',
      }}
    >
      <input {...getInputProps()} />
      <img src={icono_xlsx} alt='' style={{ width: '44px', height: '44px', objectFit: 'contain' }} />
      <Typography variant='body2' style={{ color: 'rgba(0,0,0,0.87)' }}>
        Arrastre y suelte el archivo aquí o haga clic para seleccionarlo
      </Typography>
      <Typography variant='caption' style={{ color: 'rgba(0,0,0,0.54)' }}>
        Formatos de archivo válidos: .xls, .xlsx
      </Typography>
    </div>
  );
}

function Pasos({ paso }) {
  const nombres = ['Adjuntar archivo', 'Validar datos', 'Confirmar carga'];
  return (
    <div style={{ display: 'flex', alignItems: 'center', padding: '24px 0 8px 0' }}>
      {nombres.map((nombre, i) => {
        let num = i + 1;
        let completado = num < paso;
        let activo = num === paso;
        return (
          <div key={nombre} style={{ display: 'flex', alignItems: 'center', flex: num < nombres.length ? 1 : 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', padding: '0 8px', whiteSpace: 'nowrap' }}>
              <div style={{
                width: '24px', height: '24px', borderRadius: '50%', marginRight: '8px',
                background: completado || activo ? ROJO : 'rgba(0,0,0,0.38)', color: '#fff',
                fontSize: '12px', fontWeight: 500, display: 'flex',
                alignItems: 'center', justifyContent: 'center',
              }}>{completado ? '✓' : num}</div>
              <Typography variant='body2' style={{ color: activo ? 'rgba(0,0,0,0.87)' : 'rgba(0,0,0,0.54)', fontWeight: activo ? 500 : 400 }}>
                {nombre}
              </Typography>
            </div>
            {num < nombres.length && <div style={{ flex: 1, height: '1px', background: '#bdbdbd', margin: '0 8px' }} />}
          </div>
        );
      })}
    </div>
  );
}

function Resumen({ etiqueta, valor, color }) {
  return (
    <Grid item xs={12} sm={4}>
      <Paper elevation={1} style={{ border: '1px solid #e0e0e0', borderLeft: `5px solid ${color}`, padding: '14px 16px' }}>
        <Typography variant='caption' style={{ color: 'rgba(0,0,0,0.54)', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
          {etiqueta}
        </Typography>
        <Typography style={{ fontSize: '26px', fontWeight: 700, lineHeight: 1.3, color }}>
          {valor}
        </Typography>
      </Paper>
    </Grid>
  );
}

class CargaMasivaConvenios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paso: 1,
      archivo: null,
      filas: [],
      filtro: 'todas',
      pagina: 0,
      porPagina: 5,
      cargando: false,
      guardado: false,   // solo evita un segundo envio mientras se sale de la pantalla
      mensajeCargando: 'Validando archivo..',
      paises: [],
    };
  }

  async componentDidMount() {
    let paises = await obtenerValores(PAISES);
    this.setState({ paises: (paises || []).map(({ nombre }) => nombre).filter(Boolean).sort() });
  }

  obtenerCodigosExistentes() {
    return new Promise((resolve) => {
      consulta(`api/v1.0/internacionalizacion/listar-instituciones/`, null, null, (error, estado, resp) => {
        if (!error && estado === 200 && resp && resp.instituciones) {
          resolve(resp.instituciones.map(({ codigo_convenio }) => codigo_convenio).filter(Boolean));
        } else resolve([]);
      });
    });
  }

  validar = async () => {
    let { actualizarMensaje } = this.props;
    let { archivo } = this.state;
    if (!archivo) return;
    this.setState({ cargando: true, mensajeCargando: 'Validando archivo..' });
    try {
      let crudas = await leerArchivo(archivo);
      let existentes = await this.obtenerCodigosExistentes();
      let filas = validarFilas(crudas, existentes, this.state.paises);
      this.setState({ filas, paso: 2, filtro: 'todas', pagina: 0, cargando: false });
    } catch (e) {
      this.setState({ cargando: false });
      actualizarMensaje({ titulo: e.message, tipo: 'info', mostrar: true, tiempo: 8000 });
    }
  }

  descargarPlantilla = () => {
    let { actualizarMensaje } = this.props;
    generarPlantilla(this.state.paises).catch(() => {
      actualizarMensaje({ titulo: 'No fue posible generar la plantilla.', tipo: 'error', mostrar: true, tiempo: 6000 });
    });
  }

  confirmar = () => {
    if (this.state.filas.filter(({ error }) => !error).length === 0) return;
    this.setState({ paso: 3 });
  }

  finalizar = () => {
    let { actualizarMensaje } = this.props;
    let validas = this.state.filas.filter(({ error }) => !error);
    if (validas.length === 0 || this.state.guardado) return;
    this.setState({ cargando: true, mensajeCargando: 'Guardando convenios..' });
    consulta('api/v1.0/internacionalizacion/convenios/cargar_masivo', { convenios: validas }, 'post',
      (error, estado, resp) => {
        if (error || estado !== 200 || !resp) {
          this.setState({ cargando: false });
          actualizarMensaje({
            titulo: resp && resp.titulo ? resp.titulo : 'Ha ocurrido un error, contacte con el administrador.',
            tipo: 'error', mostrar: true, tiempo: 8000,
          });
          return;
        }
        // Como se sale de la pantalla, el aviso es el unico rastro de lo rechazado.
        let rechazadas = (resp.fallidos || []).length;
        this.setState({ guardado: true, cargando: false });
        actualizarMensaje({
          titulo: rechazadas === 0 ? resp.titulo : `${resp.titulo} ${rechazadas === 1
            ? 'El servidor rechazó una fila'
            : `El servidor rechazó ${rechazadas} filas`}: corrija el Excel y vuelva a subirlo.`,
          tipo: resp.creados > 0 ? 'success' : 'info',
          mostrar: true, tiempo: rechazadas === 0 ? 6000 : 10000,
        });
        this.props.volver();
      });
  }

  pintarNota() {
    return (
      <Paper elevation={0} square style={{ background: '#fffde7', borderBottom: `5px solid ${ROJO_CLARO}`, padding: '5px' }}>
        <div style={{ display: 'flex', alignItems: 'center', padding: '4px 8px', color: '#757575' }}>
          <NotificationImportantIcon style={{ fontSize: '15px', marginRight: '6px' }} />
          <Typography variant='caption' style={{ fontWeight: 500, textTransform: 'uppercase' }}>Nota</Typography>
        </div>
        <div style={{ padding: '0 13px 10px 13px', color: '#757575' }}>
          <Typography variant='body2' style={{ fontSize: '12px', lineHeight: 1.8 }}>
            Descargue la plantilla y no cambie los encabezados ni el orden de las columnas.
          </Typography>
          <Typography variant='body2' style={{ fontSize: '12px', lineHeight: 1.8 }}>
            Use los desplegables de <strong>Renovación</strong> y <strong>Estado</strong>; la vigencia en años y las fechas en {FORMATO_FECHA}.
          </Typography>
          <Typography variant='body2' style={{ fontSize: '12px', lineHeight: 1.8 }}>
            Si el código de un convenio ya existe, esa fila se reporta como duplicada y no se carga.
          </Typography>
        </div>
      </Paper>
    );
  }

  pintarPaso1() {
    let { archivo } = this.state;
    return (
      <div style={{ paddingTop: '8px' }}>
        {this.pintarNota()}
        <Paper elevation={1} style={{ border: '1px solid #e0e0e0', padding: '24px', marginTop: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap' }}>
            <Typography variant='body1'>Adjuntar archivo</Typography>
            <Button size='small' style={{ color: ROJO }} startIcon={<GetAppIcon style={{ fontSize: '18px' }} />}
              onClick={this.descargarPlantilla}>
              Descargar plantilla
            </Button>
          </div>
          <ZonaArchivo onArchivo={(f) => this.setState({ archivo: f })} />
          {
            archivo &&
            <div style={{ marginTop: '16px', display: 'flex', alignItems: 'center', border: '1px solid #e0e0e0', padding: '10px 14px' }}>
              <img src={icono_xlsx} alt='' style={{ width: '28px', height: '28px', marginRight: '12px', objectFit: 'contain' }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <Typography variant='body2'>{archivo.name}</Typography>
                <Typography variant='caption' style={{ color: 'rgba(0,0,0,0.54)' }}>
                  {Math.max(1, Math.round(archivo.size / 1024))} KB
                </Typography>
              </div>
              <Button size='small' style={{ color: ROJO }} onClick={() => this.setState({ archivo: null })}>Quitar</Button>
            </div>
          }
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
            <Button style={{ color: ROJO }} onClick={this.props.volver}>Cancelar</Button>
            <Button disabled={!archivo} style={{ color: archivo ? ROJO : 'rgba(0,0,0,0.26)' }} onClick={this.validar}>
              Validar archivo
            </Button>
          </div>
        </Paper>
      </div>
    );
  }

  pintarTabla(lista) {
    return (
      <div style={{ overflowX: 'auto', maxWidth: '100%', WebkitOverflowScrolling: 'touch' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: '1240px', fontSize: '13px' }}>
          <thead>
            <tr>
              {['#', 'Estado fila'].concat(COLUMNAS.map(({ etiqueta }) => etiqueta)).map((t) => (
                <th key={t} style={{ textAlign: 'left', fontWeight: 500, borderBottom: '1px solid #e0e0e0', padding: '10px 12px', background: '#fafafa', whiteSpace: 'nowrap' }}>{t}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {lista.map((fila) => {
              let err = !!fila.error;
              let campos = fila.campos_error || [];
              // El motivo va en fila propia: en la celda estrechaba la columna.
              return (
                <React.Fragment key={fila.n}>
                  <tr style={{ background: err ? '#fff5f5' : '#ffffff' }}>
                    <td style={{ borderBottom: err ? 'none' : '1px solid #e0e0e0', padding: '10px 12px', color: 'rgba(0,0,0,0.54)' }}>{fila.n}</td>
                    <td style={{ borderBottom: err ? 'none' : '1px solid #e0e0e0', padding: '10px 12px', whiteSpace: 'nowrap' }}>
                      <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 500, color: '#fff', background: err ? ROJO_CLARO : VERDE }}>
                        {err ? 'Con error' : 'Válida'}
                      </span>
                    </td>
                    {COLUMNAS.map(({ clave }) => {
                      let rojo = (clave === 'FECHA_INICIO' && campos.indexOf('inicio') >= 0)
                        || (clave === 'FECHA_FINALIZACION' && campos.indexOf('fin') >= 0)
                        || campos.indexOf(clave) >= 0;
                      return (
                        <td key={clave} style={{ borderBottom: err ? 'none' : '1px solid #e0e0e0', padding: '10px 12px', whiteSpace: 'nowrap', color: rojo ? ROJO_CLARO : 'rgba(0,0,0,0.87)' }}>
                          {clave === 'OBSERVACION' && !fila[clave] ? '—' : fila[clave]}
                        </td>
                      );
                    })}
                  </tr>
                  {
                    err &&
                    <tr style={{ background: '#fff5f5' }}>
                      <td colSpan={2 + COLUMNAS.length} style={{ borderBottom: '1px solid #e0e0e0', padding: '0 12px 10px 12px', fontSize: '12px', color: ROJO_CLARO }}>
                        {fila.error}
                      </td>
                    </tr>
                  }
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  pintarPaso2() {
    let { filas, filtro, pagina, porPagina, archivo } = this.state;
    let validas = filas.filter(({ error }) => !error);
    let conError = filas.filter(({ error }) => error);
    let lista = filtro === 'validas' ? validas : filtro === 'errores' ? conError : filas;

    let ultima = Math.max(0, Math.ceil(lista.length / porPagina) - 1);
    let pag = Math.min(pagina, ultima);
    let desde = lista.length === 0 ? 0 : pag * porPagina + 1;
    let hasta = Math.min((pag + 1) * porPagina, lista.length);
    let visibles = lista.slice(pag * porPagina, pag * porPagina + porPagina);

    let opciones = [
      { id: 'todas', etiqueta: `Todas (${filas.length})` },
      { id: 'validas', etiqueta: `Válidas (${validas.length})` },
      { id: 'errores', etiqueta: `Con errores (${conError.length})` },
    ];

    return (
      <div style={{ paddingTop: '8px' }}>
        <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderBottom: '1px solid #e0e0e0', flexWrap: 'wrap' }}>
            <div>
              <Typography variant='body1'>Previsualización de convenios</Typography>
              <Typography variant='body2' style={{ color: 'rgba(0,0,0,0.54)' }}>{archivo ? archivo.name : ''}</Typography>
            </div>
            <div style={{ display: 'flex' }}>
              {opciones.map((o) => (
                <div key={o.id} onClick={() => this.setState({ filtro: o.id, pagina: 0 })}
                  style={{
                    padding: '6px 14px', marginLeft: '4px', fontSize: '13px', fontWeight: 500, cursor: 'pointer', borderRadius: '16px',
                    background: filtro === o.id ? '#fff1f0' : '#ffffff',
                    color: filtro === o.id ? ROJO : 'rgba(0,0,0,0.54)',
                    border: `1px solid ${filtro === o.id ? ROJO_CLARO : '#e0e0e0'}`,
                  }}>{o.etiqueta}</div>
              ))}
            </div>
          </div>

          {this.pintarTabla(visibles)}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '6px 16px', borderBottom: '1px solid #e0e0e0', flexWrap: 'wrap' }}>
            <Typography variant='caption' style={{ color: 'rgba(0,0,0,0.54)', marginRight: '8px' }}>Filas por página:</Typography>
            {[5, 10, 25].map((n) => (
              <div key={n} onClick={() => this.setState({ porPagina: n, pagina: 0 })}
                style={{
                  padding: '4px 9px', fontSize: '13px', borderRadius: '4px', cursor: 'pointer',
                  background: porPagina === n ? '#fff1f0' : 'transparent',
                  color: porPagina === n ? ROJO : 'rgba(0,0,0,0.87)', fontWeight: porPagina === n ? 500 : 400,
                }}>{n}</div>
            ))}
            <Typography variant='caption' style={{ color: 'rgba(0,0,0,0.54)', margin: '0 20px' }}>
              {`${desde}-${hasta} de ${lista.length}`}
            </Typography>
            <Tooltip title='Página anterior'>
              <span>
                <IconButton size='small' disabled={pag <= 0} onClick={() => this.setState({ pagina: pag - 1 })}><ChevronLeftIcon /></IconButton>
              </span>
            </Tooltip>
            <Tooltip title='Próxima página'>
              <span>
                <IconButton size='small' disabled={pag >= ultima} onClick={() => this.setState({ pagina: pag + 1 })}><ChevronRightIcon /></IconButton>
              </span>
            </Tooltip>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', flexWrap: 'wrap' }}>
            <Typography variant='caption' style={{ color: 'rgba(0,0,0,0.54)', flex: '1 1 260px', marginRight: '16px' }}>
              {
                conError.length === 0
                  ? `Se ${filas.length === 1 ? 'cargará la fila' : `cargarán las ${filas.length} filas`} del archivo.`
                  : `Se ${validas.length === 1 ? 'cargará' : 'cargarán'} ${validas.length} de ${plural(filas.length, 'fila', 'filas')}. ${conError.length === 1 ? 'La marcada con error queda' : 'Las marcadas con error quedan'} sin cargar: corrija el Excel y vuelva a subirlo.`
              }
            </Typography>
            <div style={{ marginLeft: 'auto' }}>
              <Button style={{ color: ROJO }} startIcon={<ArrowBackIosIcon style={{ fontSize: '16px' }} />} onClick={() => this.setState({ paso: 1 })}>Anterior</Button>
              <Button variant='contained' disableElevation disabled={validas.length === 0}
                style={{ backgroundColor: validas.length === 0 ? 'rgba(0,0,0,0.12)' : ROJO, color: '#fff', marginLeft: '8px' }}
                onClick={this.confirmar}>
                {`Confirmar ${validas.length} convenios`}
              </Button>
            </div>
          </div>
        </Paper>
      </div>
    );
  }

  // Solo confirmacion: al guardar se vuelve a las tarjetas de Administrar.
  pintarPaso3() {
    let { filas } = this.state;
    let conError = filas.filter(({ error }) => error);
    let cargados = filas.filter(({ error }) => !error).length;
    return (
      <div style={{ paddingTop: '8px' }}>
        <Paper elevation={1} style={{ border: '1px solid #e0e0e0', padding: '32px 24px', textAlign: 'center' }}>
          <img src={emma_s1} alt='' style={{ width: '110px', objectFit: 'contain' }} />
          <Typography variant='h6' style={{ marginTop: '16px' }}>¿ Confirmar la carga ?</Typography>
          <Typography variant='body2' style={{ color: 'rgba(0,0,0,0.54)', marginTop: '6px' }}>
            {`Se ${cargados === 1 ? 'registrará 1 convenio' : `registrarán ${cargados} convenios`}.`}
            {conError.length > 0 && ` ${plural(conError.length, 'fila quedará', 'filas quedarán')} sin cargar.`}
            {' Pulse Finalizar para guardar.'}
          </Typography>

          <Grid container spacing={1} justifyContent='center' style={{ marginTop: '24px' }}>
            <Resumen etiqueta='Convenios por cargar' valor={cargados} color={VERDE} />
            <Resumen etiqueta='Filas que no se cargarán' valor={conError.length} color={ROJO_CLARO} />
          </Grid>

          {
            conError.length > 0 &&
            <div style={{ maxWidth: '640px', margin: '24px auto 0 auto', textAlign: 'left' }}>
              <Typography variant='body2' style={{ marginBottom: '8px' }}>Filas que no se cargarán</Typography>
              {conError.map((fila) => (
                <div key={fila.n} style={{ display: 'flex', border: '1px solid #e0e0e0', borderLeft: `5px solid ${ROJO_CLARO}`, padding: '10px 14px', marginBottom: '6px' }}>
                  <Typography variant='body2' style={{ color: 'rgba(0,0,0,0.54)', minWidth: '56px' }}>{`Fila ${fila.n}`}</Typography>
                  <div style={{ minWidth: 0 }}>
                    <Typography variant='body2'>{fila.INSTITUCION}</Typography>
                    <Typography variant='caption' style={{ color: ROJO_CLARO }}>{fila.error}</Typography>
                  </div>
                </div>
              ))}
            </div>
          }

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
            <Button style={{ color: ROJO }} startIcon={<ArrowBackIosIcon style={{ fontSize: '16px' }} />} onClick={() => this.setState({ paso: 2 })}>Anterior</Button>
            <Button variant='contained' disableElevation disabled={cargados === 0}
              style={{ backgroundColor: cargados === 0 ? 'rgba(0,0,0,0.12)' : ROJO, color: '#fff', marginLeft: '8px' }}
              onClick={this.finalizar}>
              Finalizar
            </Button>
          </div>
        </Paper>
      </div>
    );
  }

  render() {
    let { paso, cargando, mensajeCargando } = this.state;
    return (
      // minmax(0, 1fr) evita que el ancho de la tabla se propague al <main>, que es
      // flex item con min-width:auto; si no, #seccion-vista lo recorta en vez de desplazar.
      <div style={{ padding: '2% 2% 0 2%', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)' }}>
        <Grid container justifyContent='center'>
          <Grid item xs={12} sm={12} md={10} lg={10} style={{ minWidth: 0 }}>
            <TituloAccion principal='' alterno='Carga masiva de convenios desde Excel' />
            <Pasos paso={paso} />
            {
              cargando
                ? <TareasTerminadas mensaje={mensajeCargando} marginTop='7%' imagen={emma_w} widthImg='7%' />
                : <>
                  {paso === 1 && this.pintarPaso1()}
                  {paso === 2 && this.pintarPaso2()}
                  {paso === 3 && this.pintarPaso3()}
                </>
            }
          </Grid>
        </Grid>
      </div>
    );
  }
}

CargaMasivaConvenios.propTypes = {
  actualizarMensaje: PropTypes.func.isRequired,
  volver: PropTypes.func.isRequired,
};

export default CargaMasivaConvenios;
